<template>
  <div class="app">
    <div class="Edit-base">
      <div class="title">编辑项目经历</div>
      <div class="Edit-content">
        <div class="content-box">
          <div class="box-item">
            <div class="item-title final">项目名称</div>
            <div class="item-content">
              <el-input size="small" placeholder="请输入项目名称" v-model="post.projectName" clearable>
              </el-input>
            </div>
          </div>
          <div class="box-item">
            <div class="item-title final">起止时间</div>
            <div class="item-content projectTime">
              <el-date-picker size="small" v-model="post.startDate" type="month" popper-class="customePopper"
                placeholder="开始日期">
              </el-date-picker>
              <span style="margin: 0 10px;">至</span>
              <el-date-picker size="small" v-model="post.endDate" type="month" class="pickerPlace"
                popper-class="customePopper" :picker-options="pickerOptions"
                :placeholder="post.endDate ? '至今' : '结束日期'">
              </el-date-picker>
            </div>
          </div>
        </div>
        <div class="content-box">
          <div class="box-item project">
            <div class="item-title final">项目描述</div>
            <div class="item-content ">
              <el-input type="textarea" :autosize="{ minRows: 6, maxRows: 6 }" placeholder="请输入项目描述"
                v-model="post.projectDesc">
              </el-input>
            </div>
          </div>
        </div>
        <div class="content-box">
          <div class="box-item project">
            <div class="item-title final">项目职责</div>
            <div class="item-content">
              <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 4 }" placeholder="请输入项目职责"
                v-model="post.projectResp">
              </el-input>
            </div>
          </div>
        </div>
        <div class="content-box">
          <div class="box-item project">
            <div class="item-title">项目业绩</div>
            <div class="item-content">
              <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 3 }" placeholder="请输入项目业绩"
                v-model="post2.projectPerf">
              </el-input>
            </div>
          </div>
        </div>
        <div class="pro-box">
          <div class="box-item">
            <div class="item-content btn">
              <el-button @click="cancel">取消</el-button>
              <el-button type="primary" @click="save">保存</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { updateproject, AddProjInfo } from '@/request/api'
export default {
  props: {
    val: {
      type: Array,
      default: function () {
        return []
      }
    },
    name: {
      type: String,
      default: ''
    },
    Index: {
      type: Number,
      default: 0
    }
  },
  created() {
    this.post.username = JSON.parse(sessionStorage.getItem('LoginInfo')).username
    if (this.name === 'AddProjectNull') {
      return;
    }
    if (this.name !== 'EditProject') {
      return;
    }
    this.post2.projID = this.val[this.Index].projectID;
    this.post2.comID = this.val[this.Index].companyID;
    this.post.startDate = this.val[this.Index].startTime;
    this.post.endDate = this.val[this.Index].endTime === '9999.0' ? '至今' : this.val[this.Index].endTime;;
    this.post.projectName = this.val[this.Index].projectName == '9999' ? '' : this.val[this.Index].projectName.replace(/<span class='HPRK'>|<\/span>/g, '');
    this.post.projectDesc = this.val[this.Index].projectDesc == '9999' ? '' : this.val[this.Index].projectDesc;
    this.post.projectDesc = this.post.projectDesc.replace(/<br\/>/g, '\n');
    this.post.projectDesc = this.post.projectDesc.replace(/<span class='HPRK'>|<\/span>/g, '');
    this.post.projectResp = this.val[this.Index].projectResponsibility == '9999' ? '' : this.val[this.Index].projectResponsibility;
    this.post.projectResp = this.post.projectResp.replace(/<br\/>/g, '\n');
    this.post.projectResp = this.post.projectResp.replace(/<span class='HPRK'>|<\/span>/g, '');
    this.post2.projectPerf = this.val[this.Index].projectPerformance == '9999' ? '' : this.val[this.Index].projectPerformance.replace(/<br\/>/g, '\n');
    this.post2.projectPerf = this.post2.projectPerf.replace(/<span class='HPRK'>|<\/span>/g, '');
  },
  data() {
    return {
      post: {
        resumeID: '',
        startDate: null,
        endDate: null,
        projectName: '',
        projectDesc: '',
        projectResp: '',
        username: ''
      },
      post2: {
        comID: '',
        projID: '',
        projectPerf: '',
      },
      pickerOptions: {
        shortcuts: [
          {
            text: "至今",
            onClick: (picker) => {
              picker.$emit("pick", '至今');
            }
          }
        ]
      }
    }
  },
  watch: {
    value2(newVal, oldVal) {
      if (newVal === '至今') {
        this.type = '至今'
      }
      var val = new Date(newVal)
      let year = val.getFullYear();
      let month = val.getMonth() + 1
    },
    deep: true
  },
  methods: {
    cancel() {
      this.$emit("projectInfoShow", false);
    },
    textBetween(str, left_key, right_key) {
      var g_left = str.indexOf(left_key);
      if (g_left != -1) {
        g_left = g_left + left_key.length;
        var g_right = str.indexOf(right_key, g_left);
      }
      if (g_right != -1) {
        return str.substr(g_left, g_right - g_left);
      }
    },
    isPostDataEmpty(post) {
      for (let key in post) {
        if (post.hasOwnProperty(key) && post[key] === '') {
          // 如果发现空属性，返回 true
          return true;
        }
      }
      // 如果所有属性都不为空，返回 false
      return false;
    },
    async save() {
      const date = new Date(this.post.startDate);
      const year = date.getFullYear();
      const month = date.getMonth() + 1; // getMonth() 返回 0-11，表示 1-12 月
      this.post.startDate = `${year}.${month.toString().padStart(2, '0')}`;
      this.post.resumeID = this.textBetween(this.$route.fullPath, 'resumeID=', '&timestamp');
      if (this.post.endDate === '至今') {
        this.post.endDate = '9999.0';
      } else {
        const date2 = new Date(this.post.endDate);
        const year2 = date2.getFullYear();
        const month2 = date2.getMonth() + 1; // getMonth() 返回 0-11，表示 1-12 月
        this.post.endDate = `${year2}.${month2.toString().padStart(2, '0')}`;
      }
      if (this.name === 'AddProjectNull') {
        if (this.isPostDataEmpty(this.post)) {
          this.$message.error('请填写完整信息');
          return;
        }
        const { data: res } = await AddProjInfo({ ...this.post, ...this.post2 });
        this.$emit("projectInfoShow", true);
      }
      if (this.name !== 'EditProject') {
        if (this.isPostDataEmpty(this.post)) {
          this.$message.error('请填写完整信息');
          return;
        }
        const { data: res } = await AddProjInfo({ ...this.post, ...this.post2 });
        this.$emit("projectInfoShow", true);
      } else {
        if (this.isPostDataEmpty(this.post)) {
          this.$message.error('请填写完整信息');
          return;
        }
        const { data: res } = await updateproject({ ...this.post, ...this.post2 });
        this.$emit("projectInfoShow", true);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.app {
  background: #fff;
  padding: 20px;

  .Edit-base {
    background: #f4f5fb;
    padding: 20px;
    box-sizing: border-box;

    .title {
      font-size: 18px;
      color: #333;
      margin-bottom: 20px;
    }

    .Edit-content {
      width: 100%;

      .content-box {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;

        .box-item {
          width: 48%;
        }

        .project {
          width: 100%;
        }

        .item-title {
          font-size: 16px;
          color: #333;
          line-height: 40px;
        }

        .final::before {
          content: "*";
          color: #f56c6c;
          margin-right: 4px;
        }

        .item-content {
          margin-bottom: 10px;
        }

        .projectTime {
          display: flex;
          align-items: center;
        }


      }

      .pro-box {
        .box-item {
          .btn {
            display: flex;
            padding-top: 20px;
            justify-content: flex-end;
            align-items: center;

            .el-button {
              width: 24%;
            }
          }
        }
      }
    }
  }
}
</style>